import { style } from 'typestyle'
export const mt8 = style({ marginTop: '8px' })
